import React from 'react';

import { indexOf, intersection, isNil, map } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { Recipient } from '@appTypes/esb/organizations/v2/_orgGuid/recipients';
import { intl } from '@modules/shared/localization/translate';
import Amount from '@paymentLogs/components/common/Amount';
import { PersonAvatar } from '@shared/components';
import PersonTag from '@shared/components/PersonTag';

import styles from './Member.module.scss';

type Props = {
  recipient: Recipient;
  balance?: number;
};

const Member: React.FC<Props> = ({ recipient, balance }) => {
  const tags = map(recipient.tags, tag => (
    <PersonTag
      key={`tag-${recipient.memberId}-${tag}`}
      size="5"
      personType={tag}
    />
  ));
  const isAdult =
    intersection(recipient.filters, ['youth', 'participant']).length === 0;
  const isYouth = indexOf(recipient.filters, 'youth') !== -1;
  const name = `${recipient.lastName}, ${recipient.firstName}`;
  const inactiveReason = intl.formatMessage({
    id: `messaging.Member.inactiveReason.${recipient.inactiveReason}`,
  });

  return (
    <div className={styles.member}>
      <div className={styles.memberRow}>
        <PersonAvatar
          className={styles.icon}
          isAdult={isAdult}
          gender={recipient.gender}
        />
        <span className={styles.memberName}>
          <FormattedMessage
            id="messaging.Member.name"
            values={{
              name,
            }}
          />
        </span>
        {!isNil(balance) && (
          <Amount amount={balance} redNegative bold addCurrency />
        )}
        <div>{isYouth ? null : tags}</div>
      </div>
      {inactiveReason !== ' ' && <span>{inactiveReason}</span>}
    </div>
  );
};

export default Member;
